import { Route } from '@angular/router';
import { IndexPage } from 'app/modules/option-type/pages/index/index.page';
import { OptionTypeDetailsPage } from 'app/modules/option-type/pages/option-type-details/option-type-details.page';

export const optionTypeDashboardRoutes: Route[] = [
    {
        path: 'option-type',
        children: [],
    },
];

export const optionTypeDataManagementRoutes: Route[] = [
    {
        path: 'option-type',
        children: [],
    },
];

export const optionTypeConfigurationRoutes: Route[] = [
    {
        path: 'option-type',
        children: [
            {
                path: '',
                component: IndexPage,
            },
            {
                path: 'option-type-details',
                component: OptionTypeDetailsPage,
            },
        ]
    },
];
